import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReviewActivity from '../components/users/ReviewActivity';
import { PageContainer, PageHeader } from '../components/layout/Page';
export default function ReviewActivityPage() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash === '#review-activity')
      document.getElementById('review-activity')?.focus();
  }, [location.hash]);
  return (
    <PageContainer width="wide">
      <PageHeader
        title="Actividad"
        description="Historial de decisiones de revisión: aprobaciones, rechazos y solicitudes de corrección."
      />
      <ReviewActivity />
    </PageContainer>
  );
}
